import { useIntl } from 'react-intl';
import DppModal from './DppModal';
import DownloadForm from '../forms/DownloadForm';

const DownloadModal = ({ show, onClose, onDownload }) => {
  const intl = useIntl();
  const modalTitle = intl.formatMessage({ id: 'download_dpp' });

  const handleDownload = (data) => {
    onDownload?.(data);
    onClose();
  };

  const footerButtons = (
    <></>
  );

  return (
    <DppModal
      show={show}
      handleClose={onClose}
      title={modalTitle}
      footerButtons={footerButtons}
      size="lg"
      centered
    >
      <DownloadForm
        onDownload={handleDownload}
        onCancel={onClose}
      />
    </DppModal>
  );
};

export default DownloadModal;